module.exports = __webpack_public_path__ + "img/topstatus.net.bcee9032.png";